import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { ValidationErrorResponseData } from '../../../services/exports/Types';

export interface SectionVisibilityProps {
  show: boolean;
  validationErrors?: ValidationErrorResponseData;
}

export interface Props extends SectionVisibilityProps {
  title?: string;
  id?: string;
  description?: string | ReactElement;
  children: any;
  className?: string;
  containerClassName?: string;
  titleClassName?: string;
}

export default function Section(props: Props): ReactElement {
  const { show, title, id, description, children, className, containerClassName, titleClassName } = props;

  return (
    // `data-open` makes the 422 -> accordion branch assertable: the body is conditionally rendered
    // on `show`, so without a marker on the always-present wrapper a spec cannot tell "collapsed"
    // from "not on this screen". `data-test` is only emitted when an id exists, so sections without
    // one stay unaddressable rather than colliding on a shared selector.
    <div
      id={id}
      data-test={id ? `section-${id}` : undefined}
      data-open={show ? 'true' : 'false'}
      className={classnames(containerClassName, !show && '!p-0 !m-0')}
    >
      {show && (
        <div className={classnames('w-full px-md lg:px-none lg:border-none', className)}>
          {title && (
            <h5
              className={classnames(
                'text-sm',
                {
                  'mb-md': !description,
                  'mb-xs': !!description,
                },
                titleClassName,
              )}
            >
              {title}
            </h5>
          )}
          {Boolean(description) && <p className="mb-md text-xs text-muted-foreground font-medium">{description}</p>}
          {children}
        </div>
      )}
    </div>
  );
}
